module.exports = __webpack_public_path__ + "static/img/bg-id.5d5f70c7.png";